import Component from '../core/Component'
import { queryAll } from '../utils/dom'
import { formatCurrency } from '../utils/Number'
import EventBus from '../core/EventBus'
import ExcelFormulas from '../utils/ExcelFormulas'
import axios from 'axios'

export const STATES = {
    ACTIVE: 'is-active',
}

const ODMENA = 7000

export default class CalculatorSavingTariff extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            rangeControls: [],
            output: null,
            total: null,
            interest: null,
            support: null,
            investment: null,
            // offerButton: null,
            printButton: null,
        }

        this.nasporenaCastka = null
    }

    prepare() {
        this.rangeControls = this.ref.rangeControls
            .map((element) => Component.getFromElement(element))
            .reduce((acc, component) => {
                component.on('change', this.update)
                acc[component.element.dataset.type] = component
                return acc
            }, {})

        // this.ref.offerButton.addEventListener('click', this.handleOfferButtonClick)
        this.ref.printButton.addEventListener('click', this.handlePrintButtonClick)

        this.update()
    }

    handleOdmenaButtonClick = (event) => {
        event.preventDefault()
        const currentButton = event.target
        currentButton.classList.add(STATES.ACTIVE)

        const buttonValue = currentButton.dataset.value
        this.ref.total.innerText = formatCurrency(
            parseInt(this.nasporenaCastka + parseInt(buttonValue)),
        )
    }

    handlePrintButtonClick = (event) => {
        event.preventDefault()

        const data = this.getPrintData()

        if (this.requestCancel) {
            this.requestCancel()
        }

        axios({
            method: 'post',
            headers: {
                'X-Request': 'JSON',
                'X-Requested-With': 'XMLHttpRequest',
            },
            cancelToken: new CancelToken((cancel) => (this.requestCancel = cancel)),
            url: this.ref.printButton.href,
            data: data,
        }).then((response) => {
            if (response.status === 200) {
                window.open(response.data)
            }
        })
    }

    // handleOfferButtonClick = (event) => {
    //     if (event.currentTarget.matches('[href^="#"]')) {
    //         event.preventDefault()
    //     } else {
    //         return
    //     }

    //     const data = this.getData()

    //     EventBus.emit('calculator:button:click', {
    //         title: event.target.dataset.text || '',
    //         product: event.target.dataset.product || '',
    //         data: data,
    //     })
    // }

    update = () => {
        const investment = this.rangeControls.investment.getValue()
        const duration = this.rangeControls.duration.getValue()
        const isValid =
            this.rangeControls.investment.isValid() && this.rangeControls.duration.isValid()

        if (!isValid) {
            this.showError()
            return
        } else {
            this.hideError()
        }

        const data = calculate(duration, investment)

        this.ref.interest.innerText = formatCurrency(data.uroky - ODMENA)
        this.ref.support.innerText = formatCurrency(data.podpora)
        this.ref.investment.innerText = formatCurrency(data.celkovyVklad)
        this.nasporenaCastka = data.nasporenaCastka
        this.ref.total.innerText = formatCurrency(data.nasporenaCastka)

        EventBus.emit('calculator:change', {
            data: this.getData(),
        })
    }

    getData() {
        const data = Object.keys(this.rangeControls).reduce((acc, key) => {
            acc[key] = this.rangeControls[key].getData()
            return acc
        }, {})

        return data
    }

    getPrintData() {
        const params = Object.keys(this.rangeControls).map((key) => {
            const { parsed, ...data } = this.rangeControls[key].getData()
            if (key === 'duration') {
                data.value = `${data.value} let`
            } else {
                data.value = formatCurrency(data.value)
            }
            return data
        })

        const values = queryAll('.calculator-Output-table tr', this.element).map((row) => ({
            label: row.querySelector('th').textContent,
            value: row.querySelector('td').textContent,
        }))

        const total = {
            label: 'Naspoříte',
            value: this.ref.total.textContent,
        }

        const title = this.ref.printButton.dataset.title

        return {
            total,
            values,
            params,
            title,
        }
    }

    showError() {
        this.ref.output.classList.add('has-error')
    }

    hideError() {
        this.ref.output.classList.remove('has-error')
    }
}

function calculate(roky, vklad) {
    var MINIMALNI_DELKA = 6

    var SAZBA = 0.015
    var VKLAD = 1700
    var DAN = 1

    var KOEFICIENT_SP = 0.05
    var MAX_SP = 20000

    var FIRST_YEAR = 2012
    var SECOND_YEAR = 2013
    var FIFTH_YEAR = 2016
    var MONTH = 1

    var numberOfDays = [31, 28, 31, 23, 7, 31, 30, 31, 31, 30, 31, 30, 31]

    // pomocne funkce
    function round(x, n) {
        var a = Math.pow(10, n)
        return Math.round(x * a) / a
    }

    // vytvori modelovu tabulku
    function getModel() {
        var model = []
        // prvni radek
        var F = FIRST_YEAR + '-' + MONTH
        var G = VKLAD
        var H = G
        var I = 0
        var J = 0
        var K = 0
        var L = 0
        var M = 0
        var N = 0
        var O = 0
        var P = 0

        model.push({
            F: F,
            G: G,
            H: H,
            I: I,
            J: J,
            K: K,
            L: L,
            M: M,
            N: N,
            O: O,
            P: P,
        })

        var j = 0 // model index
        var month = 1 // aktualni mesic

        for (var year = FIRST_YEAR; year < FIRST_YEAR + 12; year++) {
            numberOfDays.forEach(function (days, index) {
                // prvni radek predvyplneny
                if (year === FIRST_YEAR && index === 0) {
                    return
                }

                month = index === 4 ? month : (month % 12) + 1

                // vynechat statni podporu pro prvni rok
                if (year === FIRST_YEAR && index === 3) {
                    return
                }

                j++

                // vypocte bunek
                F = year + '-' + month

                G = VKLAD // TODO statni podpora
                if (index === 3) {
                    G = Math.floor(model[j - 4].M * KOEFICIENT_SP)
                }
                //odmena 7000 navic ke vkladu, druhy mesic v prvnim roce sjednani  
                if (year === FIRST_YEAR && index === 1) {
                    G += ODMENA
                }

                K = days

                K = month === 2 && !(year % 4) ? days + 1 : days

                // uprava poctu dni pro prvni rok bez statni podpory
                if (year === FIRST_YEAR && index === 4) {
                    K = 30
                }

                L = year % 4 ? 365 : 366
                
                I = round((K * model[j - 1].H * SAZBA) / L, 2)

                J = 0
                if (month === 12) {
                    // suma predchoziho roku
                    var sumJ = 0
                    for (var i = j - 12; i < j; i++) {
                        if (i > -1) {
                            // korekce pro prvni rok, kdy je zaznamu o jeden mene
                            sumJ += model[i].I
                        }
                    }
                    sumJ += I // pricist i aktualni radek
                    // if (year === FIRST_YEAR) {
                    //     J = sumJ * DAN * 2
                    // } else if (year === SECOND_YEAR) {
                    //     J = sumJ * DAN * 2
                    //     // } else if (year === FIFTH_YEAR) {
                    //     //     var partialSumJ = 0
                    //     //     for (var i = j - 12; i < j - 3; i++) {
                    //     //         partialSumJ += model[i].I
                    //     //     }
                    //     //     J = sumJ * DAN + partialSumJ
                    // } else {
                    // }
                    J = sumJ * DAN
                }

                H = G + model[j - 1].H + J

                O = 0
                if (index === 3) {
                    O = G + model[j - 13].O
                }

                M = 0
                // prvni rok jen zaklad
                if (month === 12) {
                    if (year === FIRST_YEAR) {
                        M = Math.min(H, MAX_SP)
                    } else {
                        var sumM = 0
                        for (var i = j - 1; i >= 0; i--) {
                            sumM += model[i].M
                        }
                        M = Math.min(H - model[j - 9].O - sumM, MAX_SP)
                    }
                }

                N = 0

                P = 0
                if (year > FIRST_YEAR + 5) {
                    if (index === 3) {
                        var sumM = 0
                        for (var i = j - 1; i >= 0; i--) {
                            sumM += model[i].M
                        }

                        P =
                            G +
                            model[j - 13].O +
                            Math.floor(
                                Math.min(
                                    model[j - 4].H + model[j - 3].I - model[j - 13].O - sumM,
                                    MAX_SP,
                                ) * KOEFICIENT_SP,
                            )
                    }
                }

                model[j] = {
                    F: F,
                    G: G,
                    H: H,
                    I: I,
                    J: J,
                    K: K,
                    L: L,
                    M: M,
                    N: N,
                    O: O,
                    P: P,
                }
            })
        }

        // TODO
        // dopocitat posledni 3 radky

        // prvni mesic
        month = (month % 12) + 1
        j++

        F = year + '-' + month
        G = 0
        J = 0
        H = G + model[j - 1].H + J
        L = year % 4 ? 365 : 366
        K = 31 // TODO
        I = round((K * model[j - 1].H * SAZBA) / L, 2)

        model[j] = {
            F: F,
            G: G,
            H: H,
            I: I,
            J: J,
            K: K,
            L: L,
            M: 0,
            N: 0,
            O: 0,
            P: 0,
        }

        // predposledni SP
        j++
        month = 4
        F = year + '-' + month
        G = Math.floor(model[j - 2].M * KOEFICIENT_SP)
        J = 0
        H = G + model[j - 1].H + J
        L = year % 4 ? 365 : 366

        model[j] = {
            F: F,
            G: G,
            H: H,
            I: 0,
            J: J,
            K: 0,
            L: L,
            M: 0,
            N: 0,
            O: 0,
            P: 0,
        }

        // posledni SP
        j++
        year++
        F = year + '-' + month
        var sumM = 0
        for (var i = j - 1; i >= 0; i--) {
            sumM += model[i].M
        }
        G = Math.floor(
            Math.min(model[j - 2].H + model[j - 2].I - model[j - 12].P - sumM, MAX_SP) *
                KOEFICIENT_SP,
        )
        J = 0
        H = G + model[j - 1].H + J
        L = year % 4 ? 365 : 366
        N = H
        O = G + model[j - 1].G + model[j - 12].P
        P = G + model[j - 1].G + model[j - 12].P

        model[j] = {
            F: F,
            G: G,
            H: H,
            I: 0,
            J: J,
            K: 0,
            L: L,
            M: 0,
            N: N,
            O: O,
            P: P,
        }

        // sloupec N
        // posledni radek N je zapocitany v posledni SP
        for (var year = 6; year < 12; year++) {
            j = year * 13 - 1
            var sumM = 0
            for (var i = j - 1; i >= 0; i--) {
                sumM += model[i].M
            }
            model[j].N =
                model[j - 1].H +
                model[j].I +
                model[j + 3].G +
                Math.floor(
                    Math.min(
                        model[j - 1].H +
                            model[j].I -
                            (model[j - 10].P > 0 ? model[j - 10].P : model[j - 10].O) -
                            sumM,
                        MAX_SP,
                    ) * KOEFICIENT_SP,
                )
        }

        // console.table(model)

        return model
    }

    var vyplata = function (model, index) {
        return model
            .filter(function (row) {
                return row.N > 0
            })
            .map(function (row) {
                return row.N
            })[index]
    }

    var statniPodpora = function (model, index) {
        return model
            .filter(function (row) {
                return row.P > 0
            })
            .map(function (row) {
                return row.P
            })[index]
    }

    function vynosnost(delka, vklad, vyplata) {
        var table = []

        var delka = delka + MINIMALNI_DELKA
        var R, S

        var i = 0
        for (var year = 0; year < 12; year++) {
            for (var month = 1; month < 13; month++) {
                R = FIRST_YEAR + year + '-' + month
                if (i === 0) {
                    S = vklad
                } else {
                    if (year === delka && month === 1) {
                        S = -vyplata
                    } else {
                        if (table[i - 1].S === -vyplata || table[i - 1].S === 0) {
                            S = 0
                        } else {
                            S = vklad
                        }
                    }
                }

                table[i] = {
                    R: R,
                    S: S,
                }
                i++
            }
        }

        // posledni radek
        month = 1
        R = FIRST_YEAR + year + '-' + month

        if (year === delka && month === 1) {
            S = -vyplata
        } else {
            if (table[i - 1].S === -vyplata || table[i - 1].S === 0) {
                S = 0
            } else {
                S = vklad
            }
        }

        table[i] = {
            R: R,
            S: S,
        }

        var data = table.map(function (row) {
            var dates = row.R.split('-')
            return {
                Flow: row.S,
                Date: new Date(dates[0], dates[1], 0),
            }
        })

        // console.table(table);
        return Math.round(ExcelFormulas.XIRR(data) * 100 * 100) / 100
    }

    function calc(roky, vklad, sazba) {
        VKLAD = vklad
        SAZBA = typeof sazba === 'undefined' ? SAZBA : sazba
        var model = getModel()
        var delka = roky - MINIMALNI_DELKA

        var calcVyplata = Math.round(vyplata(model, delka))
        var calcSP = statniPodpora(model, delka)
        var calcVklad = vklad * roky * 12
        var calcUroky = calcVyplata - calcVklad - calcSP
        var calcVynosnost = vynosnost(delka, vklad, calcVyplata)

        return {
            delka: roky,
            sazba: sazba,
            vklad: vklad,
            celkovyVklad: calcVklad,
            uroky: calcUroky,
            podpora: calcSP,
            nasporenaCastka: calcVyplata,
            vynosnost: calcVynosnost,
        }
    }

    return calc(roky, vklad, SAZBA)
}
